import { ORG_PAGE_IDS } from "../../constants/orgPageAccess";
import { authorizedGetRequest, postRequest } from "./httpClient";

export const normalizeOrgAllowedPages = (value) => {
  const source = Array.isArray(value) ? value : [];
  return Array.from(
    new Set(
      source
        .map((entry) => String(entry || "").trim())
        .filter((entry) => ORG_PAGE_IDS.includes(entry)),
    ),
  );
};

// getOrgPageAccess/saveOrgPageAccess only need user.token - the
// orgAllowedPages/orgPageAccessConfigured state they feed stays owned by
// ContextApi.js, since other effects there read/set it directly.
export const createOrgPageAccessApi = ({ user }) => {
  const getOrgPageAccess = async (practiceId) => {
    const resolvedPracticeId = Number.parseInt(practiceId, 10);
    if (!resolvedPracticeId) {
      return {
        practiceId: null,
        configured: false,
        allowedPages: [],
      };
    }

    const response = await authorizedGetRequest(
      user.token,
      `/api/orgPageAccess/${resolvedPracticeId}`,
    );

    return {
      practiceId: resolvedPracticeId,
      configured: Boolean(response?.configured),
      allowedPages: normalizeOrgAllowedPages(response?.allowedPages),
    };
  };

  const saveOrgPageAccess = async (practiceId, allowedPages) => {
    const resolvedPracticeId = Number.parseInt(practiceId, 10);
    if (!resolvedPracticeId) {
      throw new Error("PracticeId is required");
    }

    const response = await postRequest(
      user.token,
      `/api/orgPageAccess/${resolvedPracticeId}`,
      {
        allowedPages: normalizeOrgAllowedPages(allowedPages),
      },
    );

    return {
      practiceId: resolvedPracticeId,
      configured: Boolean(response?.configured),
      allowedPages: normalizeOrgAllowedPages(response?.allowedPages),
    };
  };

  return { getOrgPageAccess, saveOrgPageAccess };
};

// hasPageAccess reads live userType/orgAllowedPages/orgPageAccessConfigured
// state, so it's rebuilt fresh from ContextApi.js's current render (same as
// today) rather than created once - the returned function's own call
// signature, hasPageAccess(pageId, fallbackVisible), is unchanged.
export const createHasPageAccess = ({ userType, orgAllowedPages, orgPageAccessConfigured }) =>
  (pageId, fallbackVisible = false) => {
    if (userType === "admin") {
      return true;
    }

    if (orgPageAccessConfigured) {
      return orgAllowedPages.includes(pageId);
    }

    return fallbackVisible;
  };
